import { useState, useRef } from "react";
import styled from "styled-components";
import stringSimilarity from "string-similarity";

//---------------------------------------------------------

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
`;

const TopContainer = styled.div`
  width: 100%;
  height: 30px;
`;

const Input = styled.input`
  flex: 1;
  width: 100%;
  height: 100%;
  //border: 1px solid lightgray;
  background-color: whitesmoke;
  border-radius: 4px;
  padding: 0 8px;
  /* text-align: center; */

  font-size: 13px;
`;

const ListContainer = styled.div`
  flex: 1;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 0 5px 0 0;
  overflow: auto;
`;

const User = styled.div`
  font-size: 13px;
  padding: 3px 6px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: whitesmoke;
  }
`;

//---------------------------------------------------------

const UsersList = ({ onSelect, users }) => {
  const [searchInput, setSearchInput] = useState("");
  const listRef = useRef();
  const handleInputChange = (event) => {
    setSearchInput(event.target.value);
    listRef.current.scrollTop = 0;
  };

  // Calculate the similarity scores
  const similarities = stringSimilarity.findBestMatch(
    searchInput.toLowerCase(),
    users.map((mp) => mp.name.toLowerCase())
  );

  // Get the most similar strings
  const mostSimilarStrings = similarities.ratings.map((rating, index) => ({
    string: users.map((mp) => mp.name)[index],
    isModerator: users.map((mp) => mp.isModerator)[index],
    isAdmin: users.map((mp) => mp.isAdmin)[index],
    rating: rating.rating,
    id: users.map((mp) => mp._id)[index],
  }));

  // Sort by similarity score (higher score means more similar)
  const sorted = mostSimilarStrings.sort((a, b) => b.rating - a.rating);
  //put admin first, then mods, then users
  // sorted.sort((a, b) => {
  //   if (a.isAdmin && b.isAdmin) {
  //     return 0;
  //   } else if (a.isAdmin) {
  //     return -1;
  //   } else if (b.isAdmin) {
  //     return 1;
  //   } else if (a.isModerator && b.isModerator) {
  //     return 0;
  //   } else if (a.isModerator) {
  //     return -1;
  //   } else if (b.isModerator) {
  //     return 1;
  //   } else {
  //     return 0;
  //   }
  // });

  return (
    <Wrapper>
      <TopContainer>
        <Input
          autoFocus
          placeholder="Search..."
          autoCapitalize="none"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          value={searchInput}
          onChange={handleInputChange}
        />
      </TopContainer>
      <ListContainer ref={listRef}>
        {sorted.map((item, i) => {
          return (
            <User
              key={`${item.id}_${i}`}
              onClick={() => {
                const user = users.find((i) => i._id === item.id)
                onSelect(user)
              }}
            >
              {item.isAdmin && (
                <span
                  style={{
                    color: "darkorange",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  ADMIN
                </span>
              )}
              {item.isModerator && (
                <span
                  style={{
                    color: "dodgerblue",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  MOD
                </span>
              )}
              {item.string}
            </User>
          )
        })}
      </ListContainer>
    </Wrapper>
  )
};

export default UsersList;
